import { required, email } from "vee-validate/dist/rules"
import { extend } from "vee-validate"
var regex_currency = /^[0-9]+([,.][0-9]+)?$/

extend("required", {
  ...required,
  message: "This field is required"
})

extend("email", {
  ...email,
  message: "This field must be a valid email"
})

extend("currency", {
  validate: value => regex_currency.test(value),
  message: "This field must be a valid number"
})